import { cn } from '@/lib/utils';
import { ReactNode } from 'react';

interface SessionStepTitleProps {
	title?: string;
	icon?: ReactNode;
	className?: string;
}

const SessionStepTitle = ({
	title,
	icon,
	className,
}: SessionStepTitleProps) => {
	return (
		<div className={cn('flex w-full items-center gap-1', className)}>
			<div className=" h-fit">{icon && icon}</div>
			<h1
				className={cn(
					'text-md flex font-semibold leading-5 text-dark md:text-lg',
					className,
				)}
			>
				{title}
			</h1>
		</div>
	);
};

export { SessionStepTitle };
